import { defineMessages } from 'react-intl';

const messages = defineMessages({
    brand: {
        id: 'radicalstart.brand',
        defaultMessage: 'RadicalStart',
        description: 'Brand name displayed in header',
    },
    about: {
        id: 'radicalstart.about',
        defaultMessage: 'About',
        description: 'About Nav link',
    },
    login: {
        id: 'radicalstart.login',
        defaultMessage: 'Login',
        description: 'Login Nav link',
    },
    signup: {
        id: 'radicalstart.signup',
        defaultMessage: 'Sign up',
        description: 'Sign up Nav link',
    },
    contact: {
        id: 'radicalstart.contact',
        defaultMessage: 'Contact',
        description: 'Contact Nav link',
    },
    bannerTitle: {
        id: 'radicalstart.bannerTitle',
        defaultMessage: 'React',
        description: 'Title in page header',
    },
    logo: {
        id: 'radicalstart.logo',
        defaultMessage: 'Logo',
        description: 'Logo'
    },
    siteSettings: {
        id: 'radicalstart.siteSettings',
        defaultMessage: 'Site Settings',
        description: 'Site Settings'
    },
    HomeSiteSettings: {
        id: 'radicalstart.HomeSiteSettings',
        defaultMessage: 'Homepage Settings',
        description: 'HomeSiteSettings'
    },
    driverRatings: {
        id: 'radicalstart.driverRatings',
        defaultMessage: 'Service Provider Ratings',
        description: 'Driver Ratings'
    },
    messageRequired: {
        id: 'radicalstart.messageRequired',
        defaultMessage: 'Message is required',
        description: 'Message is required'
    },
    messageLength: {
        id: 'radicalstart.messageLength',
        defaultMessage: 'Message must be 200 characters or less',
        description: 'Message must be 200 characters or less'
    },
    metaKeyword: {
        id: 'radicalstart.metaKeyword',
        defaultMessage: 'Keyword must be 255 characters or less',
        description: 'Keyword must be 255 characters or less'
    },
    metaTitle: {
        id: 'radicalstart.metaTitle',
        defaultMessage: 'Meta Title',
        description: 'Meta Title'
    },
    metaDescriptionText: {
        id: 'radicalstart.metaDescriptionText',
        defaultMessage: 'Meta Description',
        description: 'Meta Description'
    },
    metaDescription: {
        id: 'radicalstart.metaDescription',
        defaultMessage: 'Description must be 255 characters or less',
        description: 'Description must be 255 characters or less'
    },
    pageTitle: {
        id: 'radicalstart.pageTitle',
        defaultMessage: 'Page Title',
        description: 'Page Title'
    },
    pageUrl: {
        id: 'radicalstart.pageUrl',
        defaultMessage: 'Page URL',
        description: 'Page URL'
    },
    invalidUrl: {
        id: 'radicalstart.invalidUrl',
        defaultMessage: 'Invalid Page URL',
        description: 'Invalid Page URL'
    },
    footerCategory: {
        id: 'radicalstart.footerCategory',
        defaultMessage: 'Footer Category',
        description: 'Footer Category'
    },
    ratings: {
        id: 'radicalstart.ratings',
        defaultMessage: 'Ratings',
        description: 'Ratings'
    },
    reasonRequired: {
        id: 'radicalstart.reasonRequired',
        defaultMessage: 'Reason is required',
        description: 'Reason is required'
    },
    exceedLimit100: {
        id: 'radicalstart.exceedLimit100',
        defaultMessage: 'Please dont exceed 100 words',
        description: 'Please dont exceed 100 words'
    },
    exceedLimit: {
        id: 'radicalstart.exceedLimit',
        defaultMessage: 'Exceeding character limit',
        description: 'Exceeding character limit'
    },
    comments: {
        id: 'radicalstart.comments',
        defaultMessage: 'Comments',
        description: 'Comments'
    },
    cancellationReasons: {
        id: 'radicalstart.cancellationReasons',
        defaultMessage: 'Cancellation Reasons',
        description: 'Cancellation Reasons'
    },
    cancellationFee: {
        id: 'radicalstart.cancellationFee',
        defaultMessage: 'Cancellation Fee',
        description: 'Cancellation Fee'
    },
    cancelReason: {
        id: 'radicalstart.cancelReason',
        defaultMessage: 'Cancel Reason',
        description: 'Cancel Reason'
    },
    cancelledBy: {
        id: 'radicalstart.cancelledBy',
        defaultMessage: 'Cancelled By',
        description: 'Cancelled By'
    },
    tripDate: {
        id: 'radicalstart.tripDate',
        defaultMessage: 'Service Date',
        description: 'Trip Date'
    },
    changePassword: {
        id: 'radicalstart.changePassword',
        defaultMessage: 'Change Password',
        description: 'Change Password'
    },
    addCancelReason: {
        id: 'radicalstart.addCancelReason',
        defaultMessage: 'Add Cancel Reason',
        description: 'Add Cancel Reason'
    },
    editCancelReason: {
        id: 'radicalstart.editCancelReason',
        defaultMessage: 'Edit Cancel Reason',
        description: 'Edit Cancel Reason'
    },
    reason: {
        id: 'radicalstart.reason',
        defaultMessage: 'Reason',
        description: 'Reason'
    },
    manageNotifications: {
        id: 'radicalstart.manageNotifications',
        defaultMessage: 'Manage Notifications',
        description: 'Manage Notifications'
    },
    bannerDesc: {
        id: 'radicalstart.bannerDesc',
        defaultMessage: 'Complex web apps made easy',
        description: 'Description in header',
    },
    recommand: {
        id: 'radicalstart.recommand',
        defaultMessage: 'Recommand',
        description: 'recommand',
    },
    sliderContent: {
        id: 'radicalstart.sliderContent',
        defaultMessage: 'Luxury',
        description: 'Luxury',
    },
    heading: {
        id: 'radicalstart.heading',
        defaultMessage: 'Heading',
        description: 'heading',
    },
    dummyText: {
        id: 'radicalstart.dummyText',
        defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
        description: 'dummyText',
    },
    rentallContent: {
        id: 'radicalstart.rentallContent',
        defaultMessage: 'RentALL',
        description: 'RentALL',
    },
    aboutFooter: {
        id: 'radicalstart.aboutFooter',
        defaultMessage: 'About Us',
        description: 'AboutFooter',
    },
    contactUs: {
        id: 'radicalstart.contactUs',
        defaultMessage: 'Contact Us',
        description: 'contact',
    },
    Trust: {
        id: 'radicalstart.Trust',
        defaultMessage: 'Trust & Safety',
        description: 'Trust',
    },
    Travel: {
        id: 'radicalstart.Travel',
        defaultMessage: 'Travel Credit',
        description: 'Trust',
    },
    Discover: {
        id: 'radicalstart.Discover',
        defaultMessage: 'Discover',
        description: 'Discover',
    },
    Hosting: {
        id: 'radicalstart.Hosting',
        defaultMessage: 'Hosting',
        description: 'Hosting',
    },
    Becomeahost: {
        id: 'radicalstart.Becomeahost',
        defaultMessage: 'Become a host',
        description: 'Becomeahost',
    },
    Terms: {
        id: 'radicalstart.Terms',
        defaultMessage: 'Terms & Privacy',
        description: 'Terms',
    },
    adminpanel: {
        id: 'radicalstart.adminpanel',
        defaultMessage: 'Admin Panel',
        description: 'admin panel',
    },
    dashboard: {
        id: 'radicalstart.dashboard',
        defaultMessage: 'Dashboard',
        description: 'dashboard',
    },
    settings: {
        id: 'radicalstart.settings',
        defaultMessage: 'Settings',
        description: 'settings',
    },
    users: {
        id: 'radicalstart.users',
        defaultMessage: 'Clients',
        description: 'users',
    },
    formssidebar: {
        id: 'radicalstart.formssidebar',
        defaultMessage: 'Forms',
        description: 'formssidebar',
    },
    email: {
        id: 'radicalstart.emailaddress',
        defaultMessage: 'Email Address',
        description: 'emailaddress',
    },
    emailaddress: {
        id: 'radicalstart.emailaddress',
        defaultMessage: 'Email Address',
        description: 'emailaddress',
    },
    password: {
        id: 'radicalstart.password',
        defaultMessage: 'Password',
        description: 'password',
    },
    select: {
        id: 'radicalstart.select',
        defaultMessage: 'Select',
        description: 'select',
    },
    textarea: {
        id: 'radicalstart.textarea',
        defaultMessage: 'Text Area',
        description: 'textarea',
    },
    firstName: {
        id: 'radicalstart.firstName',
        defaultMessage: 'First Name',
        description: 'firstName',
    },
    lastName: {
        id: 'radicalstart.lastName',
        defaultMessage: 'Last Name',
        description: 'lastName',
    },
    phoneNumber: {
        id: 'radicalstart.phoneNumber',
        defaultMessage: 'Phone Number',
        description: 'phoneNumber',
    },
    profilePicture: {
        id: 'radicalstart.profilePicture',
        defaultMessage: 'Profile Picture',
        description: 'profilePicture',
    },
    licenceFrontImage: {
        id: 'radicalstart.licenceFrontImage',
        defaultMessage: 'Licence Front Image',
        description: 'licenceFrontImage'
    },
    licenceBackImage: {
        id: 'radicalstart.licenceBackImage',
        defaultMessage: 'Licence Back Image',
        description: 'licenceBackImage'
    },
    rcImage: {
        id: 'radicalstart.rcImage',
        defaultMessage: 'RC Book Image',
        description: 'rcImage'
    },
    insuranceImage: {
        id: 'radicalstart.insuranceImage',
        defaultMessage: 'Insurance Image',
        description: 'insuranceImage'
    },
    required: {
        id: 'radicalstart.required',
        defaultMessage: '*Required',
        description: 'required error message',
    },
    emailRequired: {
        id: 'radicalstart.emailRequired',
        defaultMessage: 'Email is required',
        description: 'Email is required',
    },
    emailInvalid: {
        id: 'radicalstart.emailInValid',
        defaultMessage: 'Invalid Email Address',
        description: 'Invalid Email Address',
    },
    emailNotExists: {
        id: 'radicalstart.emailNotExists',
        defaultMessage: 'No account exists for this email. Make sure it\'s typed in correctly, or “sign up” instead',
        description: 'Email Address is not exist',
    },
    passwordRequired: {
        id: 'radicalstart.passwordRequired',
        defaultMessage: 'Password is required',
        description: 'Password is required',
    },
    passwordInvalid: {
        id: 'radicalstart.passwordInValid',
        defaultMessage: 'Your password must be at least 8 characters. Please try again',
        description: 'Invalid Password',
    },
    passwordWrong: {
        id: 'radicalstart.passwordWrong',
        defaultMessage: 'Wrong Password. Please try again',
        description: 'Wrong Password',
    },
    somethingWentWrong: {
        id: 'radicalstart.somethingWentWrong',
        defaultMessage: 'Sorry, something went wrong. Please try again',
        description: 'Wrong went wrong',
    },
    loggedIn: {
        id: 'radicalstart.loggedIn',
        defaultMessage: 'You are already logged in!',
        description: 'You are already Logged-in',
    },
    submitButton: {
        id: 'radicalstart.submitButton',
        defaultMessage: 'Submit',
        description: 'Submit',
    },
    cancelButton: {
        id: 'radicalstart.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Cancel',
    },
    table: {
        id: 'radicalstart.table',
        defaultMessage: 'Table',
        description: 'Table',
    },
    form: {
        id: 'radicalstart.form',
        defaultMessage: 'Form',
        description: 'form',
    },
    menuOne: {
        id: 'radicalstart.menuOne',
        defaultMessage: 'MenuOne',
        description: 'form',
    },
    menuTwo: {
        id: 'radicalstart.menuTwo',
        defaultMessage: 'MenuTwo',
        description: 'MenuTwo',
    },
    menuFour: {
        id: 'radicalstart.menuFour',
        defaultMessage: 'MenuFour',
        description: 'menuFour',
    },
    subMenuOne: {
        id: 'radicalstart.subMenuOne',
        defaultMessage: 'subMenuOne',
        description: 'subMenuOne',
    },
    subMenuTwo: {
        id: 'radicalstart.subMenuTwo',
        defaultMessage: 'subMenuTwo',
        description: 'subMenuTwo',
    },
    subMenuThree: {
        id: 'radicalstart.subMenuThree',
        defaultMessage: 'subMenuThree',
        description: 'subMenuThree',
    },
    siteAdmin: {
        id: 'radicalstart.siteAdmin',
        defaultMessage: 'Site Admin',
        description: 'siteAdmin',
    },
    ridersMenu: {
        id: 'radicalstart.ridersMenu',
        defaultMessage: 'Manage Clients',
        description: 'ridersMenu',
    },
    driverMenu: {
        id: 'radicalstart.driverMenu',
        defaultMessage: 'Manage Service Providers',
        description: 'driverMenu',
    },
    vehiclesMenu: {
        id: 'radicalstart.vehiclesMenu',
        defaultMessage: 'Manage Service type',
        description: 'vehiclesMenu',
    },
    categoryMenu: {
        id: 'radicalstart.categoryMenu',
        defaultMessage: 'Service Category Management',
        description: 'categoryMenu',
    },
    categorieslist: {
        id: 'radicalstart.categorieslist',
        defaultMessage: 'Categories',
        description: 'categoryMenu',
    },
    bookingsMenu: {
        id: 'radicalstart.bookingsMenu',
        defaultMessage: 'Manage Bookings',
        description: 'bookingsMenu',
    },
    Wooberly: {
        id: 'radicalstart.Wooberly',
        defaultMessage: 'Wooberly',
        description: 'Wooberly',
    },
    city: {
        id: 'radicalstart.city',
        defaultMessage: 'Lorem Ipsum is simply dummy text',
        description: 'city',
    },
    categoryTitle: {
        id: 'radicalstart.categoryTitle',
        defaultMessage: 'Category Title',
        description: 'Category Title',
    },
    categoryContent: {
        id: 'radicalstart.categoryContent',
        defaultMessage: 'Category Content',
        description: 'Category Content',
    },
    viewCity: {
        id: 'radicalstart.viewCity',
        defaultMessage: 'View city',
        description: 'view City',
    },
    Safety: {
        id: 'radicalstart.Safety',
        defaultMessage: 'Safety',
        description: 'Safety',
    },
    safetyContent: {
        id: 'radicalstart.safetyContent',
        defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
        description: 'Safety',
    },
    safetyButton: {
        id: 'radicalstart.safetyButton',
        defaultMessage: 'View all safety features',
        description: 'safetyButton',
    },
    signupDrive: {
        id: 'radicalstart.signupDrive',
        defaultMessage: 'Sign up to drive',
        description: 'Sign up to drive',
    },
    signupRide: {
        id: 'radicalstart.signupRide',
        defaultMessage: 'Sign up to ride',
        description: 'Sign up to ride',
    },
    profileId: {
        id: 'radicalstart.profileId',
        defaultMessage: 'Profile ID',
        description: 'Profile Id for user'
    },
    country: {
        id: 'radicalstart.country',
        defaultMessage: 'Country',
        description: 'Country Name'
    },
    createdAt: {
        id: 'radicalstart.createdAt',
        defaultMessage: 'Account Created on',
        description: 'Created date'
    },
    action: {
        id: 'radicalstart.action',
        defaultMessage: 'Action',
        description: 'Action'
    },
    vehicleType: {
        id: 'radicalstart.vehicleType',
        defaultMessage: 'Service Type',
        description: 'Service Type'
    },
    minBasePrice: {
        id: 'radicalstart.minBasePrice',
        defaultMessage: 'Minimum Base Price',
        description: 'Minimum base price amount'
    },
    minHourlyRate: {
        id: 'radicalstart.minHourlyRate',
        defaultMessage: 'Minimum Hourly Rate (4 hours)',
        description: 'Minimum Hourly Rate'
    },
    riderCommission: {
        id: 'radicalstart.riderCommission',
        defaultMessage: 'Client Commission(%)',
        description: 'Rider Commission Percentage'
    },
    driverCommission: {
        id: 'radicalstart.driverCommission',
        defaultMessage: 'Service Provider Commission(%)',
        description: 'Driver Commission Percentage'
    },
    vehicleName: {
        id: 'radicalstart.vehicleName',
        defaultMessage: 'Vehicle Make and Model name',
        description: 'Vehicle Make and Model name'
    },
    vehicleNumber: {
        id: 'radicalstart.vehicleNumber',
        defaultMessage: 'Vehicle Plate Number',
        description: 'Vehicle Plate Number'
    },
    status: {
        id: 'radicalstart.status',
        defaultMessage: 'Status',
        description: 'Status Active/Inactive'
    },
    editAction: {
        id: 'radicalstart.editAction',
        defaultMessage: 'Edit',
        description: 'Edit action name'
    },
    deleteAction: {
        id: 'radicalstart.deleteAction',
        defaultMessage: 'Delete',
        description: 'Delete action name'
    },
    vehicleOwnerName: {
        id: 'radicalstart.vehicleOwnerName',
        defaultMessage: 'Service Owner Name',
        description: 'Service Owner Name'
    },
    vehicleOwnerEmail: {
        id: 'radicalstart.vehicleOwnerEmail',
        defaultMessage: 'Service Owner Email',
        description: 'Service Owner Email'
    },
    minutePrice: {
        id: 'radicalstart.minutePrice',
        defaultMessage: 'Minute Price',
        description: 'Minute Price'
    },
    hourlyPrice: {
        id: 'radicalstart.hourlyPrice',
        defaultMessage: 'Hourly Price',
        description: 'Hourly Price'
    },
    unitPrice: {
        id: 'radicalstart.unitPrice',
        defaultMessage: 'Unit Price',
        description: 'Unit Price'
    },
    riderFeeType: {
        id: 'radicalstart.riderFeeType',
        defaultMessage: 'Client Fee Type',
        description: 'Rider Fee Type'
    },
    fixedFeeType: {
        id: 'radicalstart.fixed',
        defaultMessage: 'Fixed',
        description: 'Fixed Fee Type'
    },
    percentageFeeType: {
        id: 'radicalstart.percentageFeeType',
        defaultMessage: 'Percentage',
        description: 'Percentage Fee Type'
    },
    driverFeeType: {
        id: 'radicalstart.driverFeeType',
        defaultMessage: 'Service Provider Fee Type',
        description: 'Driver Fee Type'
    },
    totalFare: {
        id: 'radicalstart.totalFare',
        defaultMessage: 'Total Service Charge',
        description: 'Total Fare'
    },
    promoCodeId: {
        id: 'radicalstart.promoCodeId',
        defaultMessage: 'Promo Code',
        description: 'Promo Code'
    },
    isSpecialTrip: {
        id: 'radicalstart.isSpecialTrip',
        defaultMessage: 'Special Trip',
        description: 'Special Trip'
    },
    specialTripPrice: {
        id: 'radicalstart.specialTripPrice',
        defaultMessage: 'Client Discount Amount',
        description: 'discount text'
    },
    riderPayableAmount: {
        id: 'radicalstart.riderPayableAmount',
        defaultMessage: 'Client Payable Amount',
        description: 'Special Trip Total Fare'
    },
    tripStatus: {
        id: 'radicalstart.tripStatus',
        defaultMessage: 'Service Status',
        description: 'Trip Status'
    },
    riderName: {
        id: 'radicalstart.riderName',
        defaultMessage: 'Client Name',
        description: 'Rider Name'
    },
    driverName: {
        id: 'radicalstart.driverName',
        defaultMessage: 'Service Provider Name',
        description: 'Driver Name'
    },
    riderEmail: {
        id: 'radicalstart.riderEmail',
        defaultMessage: 'Client Email',
        description: 'Rider Email'
    },
    driverEmail: {
        id: 'radicalstart.driverEmail',
        defaultMessage: 'Service Provider Email',
        description: 'Driver Email'
    },
    pickUpLocation: {
        id: 'radicalstart.pickupLocation',
        defaultMessage: 'Service Location',
        description: 'PickUp Location'
    },
    dropLocation: {
        id: 'radicalstart.dropLocation',
        defaultMessage: 'Service Location',
        description: 'Drop Location'
    },
    bookingId: {
        id: 'radicalstart.bookingId',
        defaultMessage: 'Booking ID',
        description: 'Booking ID'
    },
    category: {
        id: 'radicalstart.category',
        defaultMessage: 'Service Categories',
        description: 'Category'
    },
    vehicleNumber: {
        id: 'radicalstart.vehicleNumber',
        defaultMessage: 'Vehicle Plate Number',
        description: 'Vehicle Plate Number'
    },
    totalRideDistance: {
        id: 'radicalstart.totalRideDistance',
        defaultMessage: 'Service Distance',
        description: 'Total Rider Distance'
    },
    totalDuration: {
        id: 'radicalstart.totalDuration',
        defaultMessage: 'Service Duration',
        description: 'Total Duration'
    },
    vehicleId: {
        id: 'radicalstart.vehicleId',
        defaultMessage: 'Service ID',
        description: 'Service ID'
    },
    categoryId: {
        id: 'radicalstart.categoryId',
        defaultMessage: 'Category ID',
        description: 'Category ID'
    },
    view: {
        id: 'radicalstart.view',
        defaultMessage: 'View',
        description: 'View Details Link'
    },
    details: {
        id: 'radicalstart.details',
        defaultMessage: 'Details',
        description: 'Details'
    },
    riderServiceFee: {
        id: 'radicalstart.riderServiceFee',
        defaultMessage: 'Client Service Fee',
        description: 'Rider Service Fee'
    },
    driverServiceFee: {
        id: 'radicalstart.driverServiceFee',
        defaultMessage: 'Service Provider Service Fee',
        description: 'Driver Service Fee'
    },
    riderTotalFare: {
        id: 'radicalstart.riderTotalFare',
        defaultMessage: 'Client Total Service Charge',
        description: 'Rider Total Fare'
    },
    driverTotalFare: {
        id: 'radicalstart.driverTotalFare',
        defaultMessage: 'Service Provider Earnings',
        description: 'Driver Total Fare'
    },
    tripStart: {
        id: 'radicalstart.tripStart',
        defaultMessage: 'Service Start',
        description: 'Trip Start'
    },
    tripEnd: {
        id: 'radicalstart.tripEnd',
        defaultMessage: 'Service End',
        description: 'Trip End'
    },
    categoryName: {
        id: 'radicalstart.categoryName',
        defaultMessage: 'Service Categories',
        description: 'Category Name'
    },
    minutes: {
        id: 'radicalstart.minutes',
        defaultMessage: 'minutes',
        description: 'minutes'
    },
    update: {
        id: 'radicalstart.update',
        defaultMessage: 'Update',
        description: 'Update'
    },
    userStatus: {
        id: 'radicalstart.userStatus',
        defaultMessage: 'User Status',
        description: 'User Status Active/Inactive'
    },
    active: {
        id: 'radicalstart.active',
        defaultMessage: 'Active',
        description: 'Active Status'
    },
    inactive: {
        id: 'radicalstart.inactive',
        defaultMessage: 'Inactive',
        description: 'Inactive Status'
    },
    pending: {
        id: 'radicalstart.pending',
        defaultMessage: 'Pending',
        description: 'Pending Status'
    },
    banStatus: {
        id: 'radicalstart.banStatus',
        defaultMessage: 'Ban Status',
        description: 'Ban Status Permit/Ban'
    },
    permit: {
        id: 'radicalstart.permit',
        defaultMessage: 'Permit',
        description: 'Permit Status'
    },
    ban: {
        id: 'radicalstart.ban',
        defaultMessage: 'Ban',
        description: 'Ban Status'
    },
    phoneDialCode: {
        id: 'radicalstart.phoneDialCode',
        defaultMessage: 'Country Code',
        description: 'Phone Dial Code'
    },
    dropzoneUpload: {
        id: "rentall.dropzoneUpload",
        defaultMessage: "Upload a file from your computer",
        description: "Dropzone upload info"
    },
    dropzoneUploadError: {
        id: "rentall.dropzoneUploadError",
        defaultMessage: "Remove the existing image and try upload again",
        description: "Dropzone upload error message"
    },
    riderFeeValue: {
        id: 'radicalstart.riderFeeValue',
        defaultMessage: 'Client Commission',
        description: 'Rider Fee Value'
    },
    driverFeeValue: {
        id: 'radicalstart.driverFeeValue',
        defaultMessage: 'Service Provider Commission',
        description: 'Driver Fee Value'
    },
    addCategory: {
        id: 'radicalstart.addCategory',
        defaultMessage: 'Add Category',
        description: 'Add category form header'
    },
    editRider: {
        id: 'radicalstart.editRider',
        defaultMessage: 'Edit Client',
        description: 'Edit rider form header'
    },
    editDriver: {
        id: 'radicalstart.editDriver',
        defaultMessage: 'Edit Service Provider',
        description: 'Edit driver form header'
    },
    editCategory: {
        id: 'radicalstart.editCategory',
        defaultMessage: 'Edit Category',
        description: 'Edit category form header'
    },
    editVehicle: {
        id: 'radicalstart.editVehicle',
        defaultMessage: 'Edit Sevice',
        description: 'Edit Sevice form header'
    },
    goBack: {
        id: 'radicalstart.goBack',
        defaultMessage: 'Go Back',
        description: 'Go Back Button Text'
    },
    capacity: {
        id: 'radicalstart.capacity',
        defaultMessage: 'Capacity',
        description: 'Capacity'
    },
    floatError: {
        id: 'radicalstart.floatError',
        defaultMessage: 'It should be a number value',
        description: 'Numeric Error Response'
    },
    numericValue: {
        id: 'radicalstart.numericValue',
        defaultMessage: 'Numeric value required',
        description: 'Numeric value required'
    },
    validUrl: {
        id: 'radicalstart.validUrl',
        defaultMessage: 'Valid URL required',
        description: 'Valid URL required'
    },
    intError: {
        id: 'radicalstart.intError',
        defaultMessage: 'It should be a decimal value',
        description: 'Integer Error Response'
    },
    percentError: {
        id: 'radicalstart.percentError',
        defaultMessage: 'Choose percentage value between 1 to 99',
        description: 'Choose percentage value between 1 to 99'
    },
    phoneError: {
        id: 'radicalstart.numberError',
        defaultMessage: 'Invalid Phone Number',
        description: 'Invalid Phone Number'
    },
    countryCodeError: {
        id: 'radicalstart.countryCodeError',
        defaultMessage: 'Invalid Country Code',
        description: 'Invalid Country Code'
    },
    vehicleNumberError: {
        id: 'radicalstart.vehicleNumberError',
        defaultMessage: 'Invalid Service Number',
        description: 'Invalid Service Number'
    },
    availableSeats: {
        id: 'radicalstart.availableSeats',
        defaultMessage: 'Available Seats',
        description: 'Available Seats'
    },
    currency: {
        id: 'radicalstart.currency',
        defaultMessage: 'Currency',
        description: 'Currency Type'
    },
    invalidVehicleName: {
        id: 'radicalstart.invalidVehicleName',
        defaultMessage: 'Invalid Service Name',
        description: 'Invalid Service Name'
    },
    invalidVehicleNumber: {
        id: 'radicalstart.invalidVehicleNumber',
        defaultMessage: 'Invalid Service Number',
        description: 'Invalid Service Number'
    },
    vehicleNameError3: {
        id: 'radicalstart.vehicleNameError3',
        defaultMessage: 'Vehicle Make and Model name must be minimum 3 characters and maximum 15 characters',
        description: 'New Password must be minimum 8 characters'
    },
    manageDashboard: {
        id: 'radicalstart.manageDashboard',
        defaultMessage: 'Dashboard',
        description: 'Manage Dashboard'
    },
    chooseFile: {
        id: 'radicalstart.chooseFile',
        defaultMessage: 'Choose File',
        description: ''
    },
    categoryIcon: {
        id: 'radicalstart.categoryIcon',
        defaultMessage: 'Service Icon',
        description: ''
    },
    categoryMapMarker: {
        id: 'radicalstart.categoryMapMarker',
        defaultMessage: 'Service Map Marker',
        description: ''
    },
    maximumUploadSizeLabel: {
        id: 'radicalstart.maximumUploadSizeLabel',
        defaultMessage: 'Maximum upload size',
        description: ''
    },
    followUs: {
        id: 'radicalstart.followUs',
        defaultMessage: 'Follow  Us',
        description: 'Follow Us',
    },
    copyRights: {
        id: 'radicalstart.copyRights',
        defaultMessage: 'Wooberly 2020. All Rights Reserved',
        description: 'Copy Rights',
    },
    useFullLink: {
        id: 'radicalstart.useFullLink',
        defaultMessage: 'Usefull Links',
        description: 'Usefull Links',
    },
    startRideing: {
        id: 'radicalstart.startRideing',
        defaultMessage: 'Start Riding',
        description: 'Start Riding',
    },
    startDriving: {
        id: 'radicalstart.startDriving',
        defaultMessage: 'Start Driving',
        description: 'Start Driving',
    },
    privacyPolicies: {
        id: 'radicalstart.privacyPolicies',
        defaultMessage: 'Privacy Policy',
        description: 'Privacy Policy',
    },
    aboutFooterDesc: {
        id: 'radicalstart.aboutFooterDesc',
        defaultMessage: 'An cum maiorum repudiandae, cu eam dolore bonorum probatus. Et legere sanctus cum, quot nostrud postulant ex mei. Ad ullum audire admodum eos. Ne eam quod habeo aeque, ad decoreos.',
        description: 'aboutFooterDesc',
    },
    downloadAppText: {
        id: 'radicalstart.downloadAppText',
        defaultMessage: 'Download The Client App',
        description: 'DownloadAppText',
    },
    downloadAppTextDriver: {
        id: 'radicalstart.downloadAppTextDriver',
        defaultMessage: 'Download The Service Provider App',
        description: 'DownloadAppText',
    },
    downloadAppDesc: {
        id: 'radicalstart.downloadAppDesc',
        defaultMessage: 'Delectus scaevola elaboraret vel ad, vis no noster vocent prodesset, nec ei omittantur dissentiet. Nobis postea ei est.',
        description: 'DownloadAppTextDesc',
    },
    downloadAppDriverDesc: {
        id: 'radicalstart.downloadAppDriverDesc',
        defaultMessage: 'Delectus scaevola elaboraret vel ad, vis no noster vocent prodesset, nec ei omittantur dissentiet. Nobis postea ei est.',
        description: 'DownloadAppTextDesc',
    },
    sliderTitle: {
        id: 'radicalstart.sliderTitle',
        defaultMessage: 'Lorem Ipsum',
        description: 'sliderTitle',
    },
    sliderTitleDesc: {
        id: 'radicalstart.sliderTitleDesc',
        defaultMessage: 'Percipit repudiandae an eum, enim case eos no. Percipit tractatos pertinacia cum id, ad eos facete malorum recusabo, vis insolens perpetua definitionem ex.',
        description: 'sliderTitleDesc',
    },
    rider: {
        id: 'radicalstart.rider',
        defaultMessage: 'Client',
        description: 'Rider',
    },
    driver: {
        id: 'radicalstart.driver',
        defaultMessage: 'Service Provider',
        description: 'driver',
    },
    homeContent: {
        id: 'radicalstart.homeContent',
        defaultMessage: 'Start Riding With Wooberly',
        description: 'Start Riding With Wooberly',
    },
    gridTitleOne: {
        id: 'radicalstart.gridTitle',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleTwo: {
        id: 'radicalstart.gridTitleTwo',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleThree: {
        id: 'radicalstart.gridTitleThree',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleFour: {
        id: 'radicalstart.gridTitleFour',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleFive: {
        id: 'radicalstart.gridTitleFive',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleSix: {
        id: 'radicalstart.gridTitleSix',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridDescOne: {
        id: 'radicalstart.gridDescOne',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescTwo: {
        id: 'radicalstart.gridDescTwo',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescThree: {
        id: 'radicalstart.gridDescThree',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescFour: {
        id: 'radicalstart.gridDescFour',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescFive: {
        id: 'radicalstart.gridDescFive',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescSix: {
        id: 'radicalstart.gridDescSix',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    drivers: {
        id: 'radicalstart.drivers',
        defaultMessage: 'Service Providers',
        description: 'drivers',
    },
    today: {
        id: 'radicalstart.today',
        defaultMessage: 'Today',
        description: 'today',
    },
    weekly: {
        id: 'radicalstart.weekly',
        defaultMessage: 'This Week',
        description: 'weekly',
    },
    montly: {
        id: 'radicalstart.montly',
        defaultMessage: 'This Month',
        description: 'montly',
    },
    riders: {
        id: 'radicalstart.riders',
        defaultMessage: 'Clients',
        description: 'Riders',
    },
    bookings: {
        id: 'radicalstart.bookings',
        defaultMessage: 'Bookings',
        description: 'bookings',
    },

    logout: {
        id: 'radicalstart.logout',
        defaultMessage: 'Logout',
        description: 'logout option',
    },

    goToMainSite: {
        id: 'radicalstart.goToMainSite',
        defaultMessage: 'Go to main site',
        description: 'goToMainSite option',
    },

    managePromoCode: {
        id: 'radicalstart.managePromoCode',
        defaultMessage: 'Manage Promo Code',
        description: 'managePromoCode sidemenu',
    },
    addPromoCode: {
        id: 'radicalstart.addPromoCode',
        defaultMessage: 'Add Promo Code',
        description: 'Add PromoCode',
    },
    editPromoCode: {
        id: 'radicalstart.editPromoCode',
        defaultMessage: 'Edit Promo Code',
        description: 'Edit PromoCode',
    },
    addPage: {
        id: 'radicalstart.addPage',
        defaultMessage: "Add Page",
        description: "Add Page"
    },
    id: {
        id: 'radicalstart.id',
        defaultMessage: 'ID',
        description: 'ID text',
    },
    title: {
        id: 'radicalstart.title',
        defaultMessage: 'Title',
        description: 'text',
    },
    description: {
        id: 'radicalstart.description',
        defaultMessage: 'Description',
        description: 'text',
    },
    code: {
        id: 'radicalstart.code',
        defaultMessage: 'Code',
        description: 'text',
    },
    discount: {
        id: 'radicalstart.discount',
        defaultMessage: 'Discount',
        description: 'text',
    },
    promoType: {
        id: 'radicalstart.promoType',
        defaultMessage: 'Type',
        description: 'text',
    },
    expireDate: {
        id: 'radicalstart.expireDate',
        defaultMessage: 'Expiry Date',
        description: 'text',
    },
    percentage: {
        id: 'radicalstart.percentage',
        defaultMessage: 'Percentage',
        description: 'text',
    },
    fixedAmount: {
        id: 'radicalstart.fixedAmount',
        defaultMessage: 'Fixed Amount',
        description: 'text',
    },
    usedPromoCode: {
        id: 'radicalstart.usedPromoCode',
        defaultMessage: 'Used Promo Code',
        description: 'text',
    },
    manageCompletedTrips: {
        id: 'radicalstart.manageCompletedTrips',
        defaultMessage: 'Completed Bookings',
        description: 'CompletedTrips sidemenu',
    },
    manageCancelledTrips: {
        id: 'radicalstart.manageCancelledTrips',
        defaultMessage: 'Cancelled Bookings',
        description: 'manageCancelledTrips sidemenu',
    },
    manageCancelReason: {
        id: 'radicalstart.manageCancelReason',
        defaultMessage: 'Cancel Reason',
        description: 'Cancel Reason',
    },
    manageCurrency: {
        id: 'radicalstart.manageCurrency',
        defaultMessage: 'Manage Currency',
        description: 'manageCurrency sidemenu',
    },
    symbol: {
        id: 'radicalstart.symbol',
        defaultMessage: 'Symbol',
        description: 'currencyManagement value',
    },
    baseCurrency: {
        id: 'radicalstart.BaseCurrency',
        defaultMessage: 'Base Currency',
        description: 'currencyManagement value',
    },
    enableDisable: {
        id: 'radicalstart.enableDisable',
        defaultMessage: 'Set Enable / Disable',
        description: 'currencyManagement value',
    },
    setBaseCurrency: {
        id: 'radicalstart.setBaseCurrency',
        defaultMessage: 'Set Base Currency',
        description: 'currencyManagement value',
    },
    allowedPaymentCurrency: {
        id: 'radicalstart.allowedPaymentCurrency',
        defaultMessage: 'Allowed Payment Currency',
        description: 'currencyManagement value',
    },
    reviewsBy: {
        id: 'radicalstart.reviewsBy',
        defaultMessage: 'Reviews By',
        description: 'reviewsBy'
    },
    noResult: {
        id: 'radicalstart.noResult',
        defaultMessage: 'No results found',
        description: 'noResult'
    },
    addLocation: {
        id: 'radicalstart.addLocation',
        defaultMessage: 'Add Location',
        description: 'addLocation'
    },
    tollFee: {
        id: 'radicalstart.tollFee',
        defaultMessage: 'Additional Charges',
        description: 'tollFee'
    },
    location: {
        id: 'radicalstart.location',
        defaultMessage: 'Manage Location',
        description: 'location'
    },
    edit: {
        id: 'radicalstart.edit',
        defaultMessage: 'Edit',
        description: 'edit'
    },
    managePayout: {
        id: 'radicalstart.managePayout',
        defaultMessage: 'Manage Payout',
        description: 'managePayout'
    },
    drivPayout: {
        id: 'radicalstart.drivPayout',
        defaultMessage: 'Service Provider Payout',
        description: 'managePayout'
    },
    amount: {
        id: 'radicalstart.Amount',
        defaultMessage: 'Amount',
        description: 'Amount'
    },
    payoutStatus: {
        id: 'radicalstart.payoutStatus',
        defaultMessage: 'Payout Status',
        description: 'Payout Status'
    },
    holdPayout: {
        id: 'radicalstart.holdPayout',
        defaultMessage: 'Hold Payout',
        description: 'Hold Payout'
    },
    paymentType: {
        id: 'radicalstart.paymentType',
        defaultMessage: 'Payment Type',
        description: 'Payment Type'
    },
    yes: {
        id: 'radicalstart.yes',
        defaultMessage: 'Yes',
        description: 'Yes'
    },
    no: {
        id: 'radicalstart.no',
        defaultMessage: 'No',
        description: 'no'
    },
    homeSectionSettings: {
        id: 'radicalstart.homeSectionSettings',
        defaultMessage: 'Banner',
        description: 'Banner Settings'
    },
    homepageBanner: {
        id: 'radicalstart.homepageBanner',
        defaultMessage: 'Homepage Banner',
        description: 'Homepage Banner Settings'
    },
    aboutSectionSettings: {
        id: 'radicalstart.aboutSectionSettings',
        defaultMessage: 'Top Features',
        description: 'Top Features Settings'
    },
    citySectionSettings: {
        id: 'radicalstart.citySectionSettings',
        defaultMessage: 'Category',
        description: 'Category Settings'
    },
    safetySectionSettings: {
        id: 'radicalstart.safetySectionSettings',
        defaultMessage: 'Client App',
        description: 'Rider Apps Settings'
    },
    signupSectionSettings: {
        id: 'radicalstart.signupSectionSettings',
        defaultMessage: 'Service Provider App',
        description: 'Driver Apps Settings'
    },
    footerSectionSettings: {
        id: 'radicalstart.footerSectionSettings',
        defaultMessage: 'Footer',
        description: 'Footer Settings'
    },
    manageFailedPayout: {
        id: 'radicalstart.manageFailedPayout',
        defaultMessage: 'Failed Payout',
        description: 'Failed Payout'
    },
    title1: {
        id: 'radicalstart.title1',
        defaultMessage: 'Title 1',
        description: 'Title 1'
    },
    title2: {
        id: 'radicalstart.title2',
        defaultMessage: 'Title 2',
        description: 'Title 2'
    },
    title3: {
        id: 'radicalstart.title3',
        defaultMessage: 'Title 3',
        description: 'Title 3'
    },
    title4: {
        id: 'radicalstart.title4',
        defaultMessage: 'Title 4',
        description: 'Title 4'
    },
    title5: {
        id: 'radicalstart.title5',
        defaultMessage: 'Title 5',
        description: 'Title 5'
    },
    title6: {
        id: 'radicalstart.title6',
        defaultMessage: 'Title 6',
        description: 'Title 6'
    },
    content: {
        id: 'radicalstart.content',
        defaultMessage: 'Content',
        description: 'Content 1'
    },
    content1: {
        id: 'radicalstart.content1',
        defaultMessage: 'Content 1',
        description: 'Content 1'
    },
    content2: {
        id: 'radicalstart.content2',
        defaultMessage: 'Content 2',
        description: 'Content 2'
    },
    content3: {
        id: 'radicalstart.content3',
        defaultMessage: 'Content 3',
        description: 'Content 3'
    },
    content4: {
        id: 'radicalstart.content4',
        defaultMessage: 'Content 4',
        description: 'Content 4'
    },
    content5: {
        id: 'radicalstart.content5',
        defaultMessage: 'Content 5',
        description: 'Content 5'
    },
    content6: {
        id: 'radicalstart.content6',
        defaultMessage: 'Content 6',
        description: 'Content 6'
    },
    button: {
        id: 'radicalstart.button',
        defaultMessage: 'Button',
        description: 'Button'
    },
    aboutImage1: {
        id: 'radicalstart.aboutImage1',
        defaultMessage: 'Feature Banner #1',
        description: 'Feature Banner 1'
    },
    aboutImage2: {
        id: 'radicalstart.aboutImage2',
        defaultMessage: 'Feature Banner #2',
        description: 'Feature Banner 2'
    },
    homeImage1: {
        id: 'radicalstart.homeImage1',
        defaultMessage: 'Banner Image #1',
        description: 'Banner Image 1'
    },
    homeImage2: {
        id: 'radicalstart.homeImage2',
        defaultMessage: 'Banner Image #2',
        description: 'Banner Image 2'
    },
    homeImage3: {
        id: 'radicalstart.homeImage3',
        defaultMessage: 'Banner Image #3',
        description: 'Banner Image 3'
    },
    homeImage4: {
        id: 'radicalstart.homeImage4',
        defaultMessage: 'Banner Image #4',
        description: 'Banner Image 4'
    },
    homeImage5: {
        id: 'radicalstart.homeImage5',
        defaultMessage: 'Banner Image #5',
        description: 'Banner Image 5'
    },
    homeImage6: {
        id: 'radicalstart.homeImage6',
        defaultMessage: 'Banner Image #6',
        description: 'Banner Image 6'
    },
    homeImage7: {
        id: 'radicalstart.homeImage7',
        defaultMessage: 'Banner Image Tablet',
        description: 'Banner Image Tablet'
    },
    homeImage8: {
        id: 'radicalstart.homeImage8',
        defaultMessage: 'Banner Image Mobile',
        description: 'Banner Image Mobile'
    },
    homeTitle: {
        id: 'radicalstart.homeTitle',
        defaultMessage: 'Banner Title',
        description: 'Banner Title'
    },
    homeContent1: {
        id: 'radicalstart.homeContent1',
        defaultMessage: 'Banner Content',
        description: 'Banner Content'
    },
    safetyImage1: {
        id: 'radicalstart.safetyImage1',
        defaultMessage: 'Playstore Logo',
        description: 'Playstore Logo'
    },
    safetyImage2: {
        id: 'radicalstart.safetyImage2',
        defaultMessage: 'Appstore Logo',
        description: 'Appstore Logo'
    },
    safetyImage3: {
        id: 'radicalstart.safetyImage3',
        defaultMessage: 'Client Banner',
        description: 'Rider Banner'
    },
    signupImage1: {
        id: 'radicalstart.signupImage1',
        defaultMessage: 'Playstore Logo',
        description: 'Playstore Logo'
    },
    signupImage2: {
        id: 'radicalstart.signupImage2',
        defaultMessage: 'Appstore Logo',
        description: 'Appstore Logo'
    },
    signupImage3: {
        id: 'radicalstart.signupImage3',
        defaultMessage: 'Service Provider Banner',
        description: 'Driver Banner'
    },
    footerLogo1: {
        id: 'radicalstart.footerLogo1',
        defaultMessage: 'Footer Logo #1',
        description: 'Footer Logo 1'
    },
    footerLogo2: {
        id: 'radicalstart.footerLogo2',
        defaultMessage: 'Footer Logo #2',
        description: 'Footer Logo 2'
    },
    footerLogo3: {
        id: 'radicalstart.footerLogo3',
        defaultMessage: 'Footer Logo #3',
        description: 'Footer Logo 3'
    },
    footerLogo4: {
        id: 'radicalstart.footerLogo4',
        defaultMessage: 'Footer Logo #4',
        description: 'Footer Logo 4'
    },
    tipsAmount: {
        id: 'radicalstart.tipsAmount',
        defaultMessage: 'Tips Amount',
        description: 'Tips Amount'
    },
    earnings: {
        id: 'radicalstart.earnings',
        defaultMessage: 'Your Earnings',
        description: 'Earnings'
    },
    overAll: {
        id: 'radicalstart.overAll',
        defaultMessage: 'Overall',
        description: 'Overall'
    },
    approve: {
        id: 'radicalstart.approve',
        defaultMessage: 'Approve',
        description: 'Approve'
    },
    decline: {
        id: 'radicalstart.decline',
        defaultMessage: 'Decline',
        description: 'Decline'
    },
    online: {
        id: 'radicalstart.online',
        defaultMessage: 'Online',
        description: 'online'
    },
    offline: {
        id: 'radicalstart.offline',
        defaultMessage: 'Offline',
        description: 'offline'
    },
    eligibleForATrip: {
        id: 'radicalstart.eligibleForATrip',
        defaultMessage: 'Eligible for a Trip',
        description: 'text'
    },
    notEligibleForATrip: {
        id: 'radicalstart.notEligibleForATrip',
        defaultMessage: 'Not eligible for a Trip',
        description: 'text'
    },
    preview: {
        id: 'radicalstart.preview',
        defaultMessage: 'Preview',
        description: 'Preview'
    },
    pageName: {
        id: 'radicalstart.pageName',
        defaultMessage: 'Page Name',
        description: 'Page Name'
    },
    staticpageManagement: {
        id: 'radicalstart.staticpageManagement',
        defaultMessage: 'Manage Static Content',
        description: 'Manage Static Content'
    },
    contentpageManagement: {
        id: 'radicalstart.contentpageManagement',
        defaultMessage: 'Content Management',
        description: 'Content Management'
    },
    editPageDetails: {
        id: 'radicalstart.editPageDetails',
        defaultMessage: 'Edit Page Details',
        description: 'Edit Page Details'
    },
    pageBanner: {
        id: 'radicalstart.pageBanner',
        defaultMessage: 'Page Banner',
        description: 'Page Banner'
    },
    pageImageBanner: {
        id: 'radicalstart.pageImageBanner',
        defaultMessage: 'Page Image Banner',
        description: 'Page Image Banner'
    },
    manageFare: {
        id: 'radicalstart.manageFare',
        defaultMessage: 'Manage Fare',
        description: 'Admin sidemenu'
    },
    locationName: {
        id: 'radicalstart.locationName',
        defaultMessage: 'Location',
        description: 'Table header'
    },
    addFare: {
        id: 'radicalstart.addFare',
        defaultMessage: 'Add Fare',
        description: 'Button '
    },
    editFare: {
        id: 'radicalstart.adeditFaredFare',
        defaultMessage: 'Edit Fare',
        description: 'Button '
    },
    vechicleName: {
        id: 'radicalstart.vechicleName',
        defaultMessage: 'Service',
        description: 'Service'
    },
    paid: {
        id: 'radicalstart.paid',
        defaultMessage: 'Paid',
        description: 'Paid'
    },
    unpaid: {
        id: 'radicalstart.unpaid',
        defaultMessage: 'Unpaid',
        description: 'Unpaid'
    },
    payoutAmount: {
        id: 'radicalstart.payoutAmount',
        defaultMessage: 'Payout Amount',
        description: 'Payout Amount'
    },
    searchLocation: {
        id: 'radicalstart.searchLocation',
        defaultMessage: 'Search Location',
        description: 'Auto-Complete input'
    },
    removeLocation: {
        id: 'radicalstart.removeLocation',
        defaultMessage: 'Remove Location',
        description: 'Polygon remove'
    },
    walletBalance: {
        id: 'radicalstart.walletBalance',
        defaultMessage: 'Wallet Balance',
        description: 'Wallet Balance'
    },
    paymentMethod: {
        id: 'radicalstart.paymentMethod',
        defaultMessage: 'Payment Method',
        description: 'Payment Method'
    },
    card: {
        id: 'radicalstart.card',
        defaultMessage: 'Card',
        description: 'Card'
    },
    cash: {
        id: 'radicalstart.cash',
        defaultMessage: 'Cash',
        description: 'Cash'
    },
    wallet: {
        id: 'radicalstart.wallet',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    exportDataIntoCSV: {
        id: 'radicalstart.exportDataIntoCSV',
        defaultMessage: 'Export Data into CSV',
        description: 'Export Data into CSV',
    },
    roleName: {
        id: 'radicalstart.roleName',
        defaultMessage: 'Role Name',
        description: 'Role Name',
    },
    privileges: {
        id: 'radicalstart.privileges',
        defaultMessage: 'Privileges',
        description: 'Privileges',
    },
    emailText: {
        id: 'radicalstart.emailText',
        defaultMessage: 'Email',
        description: 'Email',
    },
    adminRole: {
        id: 'radicalstart.adminRole',
        defaultMessage: 'Admin Role',
        description: 'Admin Role',
    },
    adminName: {
        id: 'radicalstart.adminName',
        defaultMessage: 'Name',
        description: 'Name'
    },
    passwordText: {
        id: 'radicalstart.passwordText',
        defaultMessage: 'Provide new password only. Ignore this field to use the existing password for this user.',
        description: 'Password Content',
    },
    selectRole: {
        id: 'radicalstart.selectRole',
        defaultMessage: 'Select Role',
        description: 'Select Role',
    },
    role: {
        id: 'radicalstart.role',
        defaultMessage: 'Role',
        description: 'Role',
    },
    manageAdmin: {
        id: 'radicalstart.manageAdmin',
        defaultMessage: 'Manage Admins',
        description: 'Manage Admins',
    },
    manageAdminUsers: {
        id: 'radicalstart.manageAdminUsers',
        defaultMessage: 'Manage Admin Users',
        description: 'Manage Admin Users',
    },
    manageAdminRoles: {
        id: 'radicalstart.manageAdminRoles',
        defaultMessage: 'Manage Admin Roles',
        description: 'Manage Admin Roles',
    },
    adminUserLabel: {
        id: 'radicalstart.adminUserLabel',
        defaultMessage: 'Admin User',
        description: 'Admin User',
    },
    addNewLabel: {
        id: 'radicalstart.addNewLabel',
        defaultMessage: 'Add New',
        description: 'Add New',
    },
    chooseLanguageLabel: {
        id: 'radicalstart.chooseLanguageLabel',
        defaultMessage: 'Choose a Language',
        description: 'Choose a Language',
    },
    askQuestion: {
        id: 'radicalstart.askQuestion',
        defaultMessage: 'Ask a question',
        description: 'Ban Status'
    },
    reportIssue: {
        id: 'radicalstart.reportIssue',
        defaultMessage: 'Report an issue',
        description: 'Ban Status'
    },
    Enabled: {
        id: 'radicalstart.Enabled',
        defaultMessage: 'Enabled',
        description: 'Ban Status'
    },
    Disabled: {
        id: 'radicalstart.Disabled',
        defaultMessage: 'Disabled',
        description: 'Ban Status'
    },
    Enable: {
        id: 'radicalstart.Enable',
        defaultMessage: 'Enable',
        description: 'Ban Status'
    },
    Disable: {
        id: 'radicalstart.Disable',
        defaultMessage: 'Disable',
        description: 'Ban Status'
    },
    setBase: {
        id: 'radicalstart.setBase',
        defaultMessage: 'Set as base currency',
        description: 'Ban Status'
    },
    Support: {
        id: 'radicalstart.Support',
        defaultMessage: 'Support',
        description: 'Ban Status'
    },
    totalUser: {
        id: 'radicalstart.totalUser',
        defaultMessage: 'Total Users',
        description: 'Ban Status'
    },
    totalList: {
        id: 'radicalstart.totalList',
        defaultMessage: 'Total Listings',
        description: 'Ban Status'
    },
    totalReserv: {
        id: 'radicalstart.totalReserv',
        defaultMessage: 'Total Reservations',
        description: 'Ban Status'
    },
    lastHours: {
        id: 'radicalstart.lastHours',
        defaultMessage: 'Last 24 hours',
        description: 'Ban Status'
    },
    listings: {
        id: 'radicalstart.listings',
        defaultMessage: 'Listings',
        description: 'Ban Status'
    },
    reservations: {
        id: 'radicalstart.reservations',
        defaultMessage: 'Reservations',
        description: 'Ban Status'
    },
    notFound: {
        id: 'radicalstart.notFound',
        defaultMessage: 'Sorry, the page you were trying to view does not exist.',
        description: 'Ban Status'
    },
    oneOne: {
        id: 'radicalstart.oneOne',
        defaultMessage: 'One',
        description: 'Ban Status'
    },
    currencies: {
        id: 'radicalstart.currencies',
        defaultMessage: 'Currencies',
        description: 'Ban Status'
    },
    fares: {
        id: 'radicalstart.fares',
        defaultMessage: 'Fares',
        description: 'Fares'
    },
    vehicles: {
        id: 'radicalstart.vehicles',
        defaultMessage: 'Services',
        description: 'Fares'
    },
    homeonly: {
        id: 'radicalstart.homeonly',
        defaultMessage: 'Home',
        description: 'Fares'
    },
    allonly: {
        id: 'radicalstart.allonly',
        defaultMessage: 'All',
        description: 'Fares'
    },
    playstorelink: {
        id: 'radicalstart.playstorelink',
        defaultMessage: 'Play Store Link',
        description: 'Fares'
    },
    appstorelink: {
        id: 'radicalstart.appstorelink',
        defaultMessage: 'App Store Link',
        description: 'Fares'
    },
    driverappcntn: {
        id: 'radicalstart.driverappcntn',
        defaultMessage: 'Service Provider App Content',
        description: 'Fares'
    },
    driverapptitle: {
        id: 'radicalstart.driverapptitle',
        defaultMessage: 'Service Provider App Title',
        description: 'Fares'
    },
    logowidth: {
        id: 'radicalstart.logowidth',
        defaultMessage: 'Logo Width',
        description: 'Fares'
    },
    logoheight: {
        id: 'radicalstart.logoheight',
        defaultMessage: 'Logo Height',
        description: 'Fares'
    },
    siteName: {
        id: 'radicalstart.siteName',
        defaultMessage: 'Site Name',
        description: 'Fares'
    },
    siteTitle: {
        id: 'radicalstart.siteTitle',
        defaultMessage: 'Site Title',
        description: 'Fares'
    },
    metakey: {
        id: 'radicalstart.metakey',
        defaultMessage: 'Meta Keyword',
        description: 'Fares'
    },
    metaDesc: {
        id: 'radicalstart.metaDesc',
        defaultMessage: 'Meta Description',
        description: 'Fares'
    },
    facebookUrl: {
        id: 'radicalstart.facebookUrl',
        defaultMessage: 'Facebook URL',
        description: 'Fares'
    },
    twiterUrl: {
        id: 'radicalstart.twiterUrl',
        defaultMessage: 'Twitter URL',
        description: 'Fares'
    },
    instaUrl: {
        id: 'radicalstart.instaUrl',
        defaultMessage: 'Instagram URL',
        description: 'Fares'
    },
    youtubeUrl: {
        id: 'radicalstart.youtubeUrl',
        defaultMessage: 'Youtube URL',
        description: 'Fares'
    },
    miles: {
        id: 'radicalstart.miles',
        defaultMessage: 'Miles',
        description: 'Fares'
    },
    errorOnly: {
        id: 'radicalstart.errorOnly',
        defaultMessage: 'Error',
        description: 'Fares'
    },
    credentialError: {
        id: 'radicalstart.credentialError',
        defaultMessage: 'Sorry, a critical error occurred on this page.',
        description: 'Fares'
    },
    addOnly: {
        id: 'radicalstart.addOnly',
        defaultMessage: 'Address',
        description: 'Fares'
    },
    state: {
        id: 'radicalstart.state',
        defaultMessage: 'State',
        description: 'Fares'
    },
    checkmein: {
        id: 'radicalstart.checkmein',
        defaultMessage: 'Check me in',
        description: 'Fares'
    },
    checkmeout: {
        id: 'radicalstart.checkmeout',
        defaultMessage: 'Check me out',
        description: 'Fares'
    },
    tableHead: {
        id: 'radicalstart.tableHead',
        defaultMessage: 'Table heading',
        description: 'Fares'
    },
    tableCell: {
        id: 'radicalstart.tableCell',
        defaultMessage: 'Table cell',
        description: 'Fares'
    },
    redioOne: {
        id: 'radicalstart.redioOne',
        defaultMessage: 'radio 1',
        description: 'Fares'
    },
    optionOne: {
        id: 'radicalstart.optionOne',
        defaultMessage: 'option 1',
        description: 'Fares'
    },
    confirmPassword: {
        id: 'radicalstart.confirmPassword',
        defaultMessage: 'Confirm Password',
        description: 'Change Password'
    },
    nameOnly: {
        id: 'radicalstart.nameOnly',
        defaultMessage: 'Name',
        description: 'Change Password'
    },
    msgOnly: {
        id: 'radicalstart.msgOnly',
        defaultMessage: 'Message',
        description: 'Change Password'
    },
    featureTitle1: {
        id: 'radicalstart.featureTitle1',
        defaultMessage: 'Feature Title #1',
        description: 'Change Password'
    },
    featureTitle2: {
        id: 'radicalstart.featureTitle2',
        defaultMessage: 'Feature Title #2',
        description: 'Change Password'
    },
    featureTitle3: {
        id: 'radicalstart.featureTitle3',
        defaultMessage: 'Feature Title #3',
        description: 'Change Password'
    },
    featureTitle4: {
        id: 'radicalstart.featureTitle4',
        defaultMessage: 'Feature Title #4',
        description: 'Change Password'
    },
    featureTitle5: {
        id: 'radicalstart.featureTitle5',
        defaultMessage: 'Feature Title #5',
        description: 'Change Password'
    },
    featureTitle6: {
        id: 'radicalstart.featureTitle6',
        defaultMessage: 'Feature Title #6',
        description: 'Change Password'
    },
    featureDesc1: {
        id: 'radicalstart.featureDesc1',
        defaultMessage: 'Feature Description #1',
        description: 'Change Password'
    },
    featureDesc2: {
        id: 'radicalstart.featureDesc2',
        defaultMessage: 'Feature Description #2',
        description: 'Change Password'
    },
    featureDesc3: {
        id: 'radicalstart.featureDesc3',
        defaultMessage: 'Feature Description #3',
        description: 'Change Password'
    },
    featureDesc4: {
        id: 'radicalstart.featureDesc4',
        defaultMessage: 'Feature Description #4',
        description: 'Change Password'
    },
    featureDesc5: {
        id: 'radicalstart.featureDesc5',
        defaultMessage: 'Feature Description #5',
        description: 'Change Password'
    },
    featureDesc6: {
        id: 'radicalstart.featureDesc6',
        defaultMessage: 'Feature Description #6',
        description: 'Change Password'
    },
    footerTitle1: {
        id: 'radicalstart.footerTitle1',
        defaultMessage: 'Footer Title #1',
        description: 'Change Password'
    },
    footerContent1: {
        id: 'radicalstart.footerContent1',
        defaultMessage: 'Footer Content #1',
        description: 'Change Password'
    },
    footerUrltitle: {
        id: 'radicalstart.footerUrltitle',
        defaultMessage: 'Footer URL Title',
        description: 'Change Password'
    },
    copyRightcontent: {
        id: 'radicalstart.copyRightcontent',
        defaultMessage: 'Copyrights content',
        description: 'Change Password'
    },
    radioButton: {
        id: 'radicalstart.radioButton',
        defaultMessage: 'Radio button',
        description: 'Change Password'
    },
    buttonLabel: {
        id: 'radicalstart.buttonLabel',
        defaultMessage: 'Button Label',
        description: 'Change Password'
    },
    riderApptitle: {
        id: 'radicalstart.riderApptitle',
        defaultMessage: 'Client App Title',
        description: 'Change Password'
    },
    riderAppContent: {
        id: 'radicalstart.riderAppContent',
        defaultMessage: 'Client App Content',
        description: 'Change Password'
    },
    leaveEmail: {
        id: 'radicalstart.leaveEmail',
        defaultMessage: 'Leave email address field blank if you don\'t want to change the email',
        description: 'Change Password'
    },
    searchOnly: {
        id: 'radicalstart.searchOnly',
        defaultMessage: 'Search',
        description: 'Change Password'
    },
    add: {
        id: 'radicalstart.add',
        defaultMessage: 'Add',
        description: 'Add Button',
    },
    topFeatures: {
        id: 'radicalstart.topFeatures',
        defaultMessage: 'Top Features Section Settings',
        description: 'Top Features Section Settings',
    },
    driverPayout: {
        id: 'radicalstart.driverPayout',
        defaultMessage: 'Manage Service Provider Payouts',
        description: 'Manage Driver Payouts'
    },
    changeAdminPassword: {
        id: 'radicalstart.changeAdminPassword',
        defaultMessage: 'Change Admin Email/Password',
        description: 'Change Admin Email/Password'
    },
    currencyList: {
        id: 'radicalstart.currencyList',
        defaultMessage: 'Currency List',
        description: 'Currency List'
    },
    editLocation: {
        id: 'radicalstart.editLocation',
        defaultMessage: 'Edit Location',
        description: 'Edit Location'
    },
    bookingDetails: {
        id: 'radicalstart.bookingDetails',
        defaultMessage: 'Booking Details',
        description: 'Booking Details'
    },
    riderAndriodVersion: {
        id: 'radicalstart.riderAndriodVersion',
        defaultMessage: 'Client Android Version',
        description: 'riderAndriodVersion'
    },
    rideriosVersion: {
        id: 'radicalstart.rideriosVersion',
        defaultMessage: 'Client iOS Version',
        description: 'rideriosVersion'
    },
    driverAndriodVersion: {
        id: 'radicalstart.driverAndriodVersion',
        defaultMessage: 'Service Provider Android Version',
        description: 'Andriod'
    },
    driveriosVersion: {
        id: 'radicalstart.driveriosVersion',
        defaultMessage: 'Service Provider iOS Version',
        description: 'iOS'
    },
    forceUpdate: {
        id: 'radicalstart.forceUpdate',
        defaultMessage: 'Force update',
        description: 'forceUpdate'
    },
    invalidVersionNumber: {
        id: 'radicalstart.invalidVersionNumber',
        defaultMessage: 'Invalid Version Number',
        description: 'invalidVersionNumber'
    },
    to: {
        id: 'radicalstart.to',
        defaultMessage: 'To',
        description: 'Label'
    },
    validatePasswordLength: {
        id: 'radicalstart.validatePasswordLength',
        defaultMessage: 'Password must be minimum 8 characters',
        description: 'Password length Validation'
    },
    validateConfirmPasswordLength: {
        id: 'radicalstart.validateConfirmPasswordLength',
        defaultMessage: 'Confirm Password must be minimum 8 characters',
        description: 'Confirm Password length Validation'
    },
    validatePasswordMatch: {
        id: 'radicalstart.validatePasswordMatch',
        defaultMessage: 'Password is mismatching with Confirm password',
        description: 'Password mismatch'
    },
    rideFare: {
        id: 'radicalstart.rideFare',
        defaultMessage: 'Service Fare',
        description: 'Label'
    },
    riderBillingInformation: {
        id: 'radicalstart.riderBillingInformation',
        defaultMessage: 'Client Billing Information',
        description: 'Label'
    },
    driverBillingInformation: {
        id: 'radicalstart.driverBillingInformation',
        defaultMessage: 'Service Provider Billing Information',
        description: 'Label'
    },
    driverEarnings: {
        id: 'radicalstart.driverEarnings',
        defaultMessage: 'Service Provider Earnings',
        description: 'Label'
    },
    tipsReceivedFromRider: {
        id: 'radicalstart.tipsReceivedFromRider',
        defaultMessage: 'Tips received from the client',
        description: 'Label'
    },
    tipsGivenToDriver: {
        id: 'radicalstart.tipsGivenToDriver',
        defaultMessage: 'Tips given to the Service Provider',
        description: 'Label'
    },
    platformEarnings: {
        id: 'radicalstart.platformEarnings',
        defaultMessage: 'Platform Earnings',
        description: 'Label'
    },
    platformOffered: {
        id: 'radicalstart.platformOffered',
        defaultMessage: 'Platform Overdrafts',
        description: 'Label'
    },
    processedCash: {
        id: 'radicalstart.processedCash',
        defaultMessage: 'Processed via cash',
        description: 'Label'
    },
    completedLabel: {
        id: 'radicalstart.completedLabel',
        defaultMessage: 'Completed',
        description: 'Label'
    },
    pendingLabel: {
        id: 'radicalstart.pendingLabel',
        defaultMessage: 'Pending',
        description: 'Label'
    },
    notRequired: {
        id: 'radicalstart.notRequired',
        defaultMessage: 'No Action Required',
        description: 'Label'
    },
    walletBalance: {
        id: 'radicalstart.walletBalance',
        defaultMessage: 'Wallet Balance',
        description: 'Wallet Balance'
    },
    paymentMethod: {
        id: 'radicalstart.paymentMethod',
        defaultMessage: 'Payment Method',
        description: 'Payment Method'
    },
    card: {
        id: 'radicalstart.card',
        defaultMessage: 'Card',
        description: 'Card'
    },
    cash: {
        id: 'radicalstart.cash',
        defaultMessage: 'Cash',
        description: 'Cash'
    },
    wallet: {
        id: 'radicalstart.wallet',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    exportDataIntoCSV: {
        id: 'radicalstart.exportDataIntoCSV',
        defaultMessage: 'Export Data into CSV',
        description: 'Export Data into CSV',
    },
    addAdminRole: {
        id: 'radicalstart.addAdminRole',
        defaultMessage: 'Add Admin Role',
        description: 'Title'
    },
    editAdminRole: {
        id: 'radicalstart.editAdminRole',
        defaultMessage: 'Edit Admin Role',
        description: 'Title'
    },
    locations: {
        id: 'radicalstart.locations',
        defaultMessage: 'Locations',
        description: 'Pagination'
    },
    addAdminUserLabel: {
        id: 'radicalstart.addAdminUserLabel',
        defaultMessage: 'Add Admin User',
        description: 'Add Admin User'
    },
    editAdminUserLabel: {
        id: 'radicalstart.editAdminUserLabel',
        defaultMessage: 'Edit Admin User',
        description: 'Edit Admin User'
    },
    completed: {
        id: 'radicalstart.completed',
        defaultMessage: 'Completed',
        description: 'Completed Status'
    },
    approved: {
        id: 'radicalstart.approved',
        defaultMessage: 'Approved',
        description: 'Approved Status'
    },
    declined: {
        id: 'radicalstart.declined',
        defaultMessage: 'Declined',
        description: 'Declined Status'
    },
    started: {
        id: 'radicalstart.started',
        defaultMessage: 'Started',
        description: 'Started Status'
    },
    cancelledByRider: {
        id: 'radicalstart.cancelledByRider',
        defaultMessage: 'Cancelled By Client',
        description: 'Cancelled By Rider Status'
    },
    cancelledByDriver: {
        id: 'radicalstart.cancelledByDriver',
        defaultMessage: 'Cancelled By Service Provider',
        description: 'Cancelled By Driver Status'
    },
    expired: {
        id: 'radicalstart.expired',
        defaultMessage: 'Expired',
        description: 'Expired Status'
    },
    notRequiredMessage: {
        id: 'radicalstart.notRequiredMessage',
        defaultMessage: 'Not Required',
        description: 'Not Required'
    },
    driverPrivacyPolicy: {
        id: 'radicalstart.driverPrivacyPolicy',
        defaultMessage: 'Service Provider Privacy Policy',
        description: 'Title',
    },
    precautionNotification: {
        id: 'radicalstart.precautionNotification',
        defaultMessage: 'Precaution Notification',
        description: 'Title',
    },
    image: {
        id: 'radicalstart.image',
        defaultMessage: 'Image',
        description: 'Label',
    },
    scheduleBooking: {
        id: 'radicalstart.scheduleBooking',
        defaultMessage: 'Schedule Bookings',
        description: 'Label'
    },
    scheduled: {
        id: 'radicalstart.scheduled',
        defaultMessage: 'Scheduled',
        description: 'Trip status'
    },
    scheduledFrom: {
        id: 'radicalstart.scheduledFrom',
        defaultMessage: 'Scheduled From',
        description: 'Label'
    },
    scheduledTo: {
        id: 'radicalstart.scheduledTo',
        defaultMessage: 'Scheduled To',
        description: 'Label'
    },
    failed: {
        id: 'radicalstart.failed',
        defaultMessage: 'Failed',
        description: 'Trip Status of Schedule History'
    },
    updated: {
        id: 'radicalstart.updated',
        defaultMessage: 'Updated',
        description: 'Trip Status of Schedule History'
    },
    scheduleBookingHistory: {
        id: 'radicalstart.scheduleBookingHistory',
        defaultMessage: 'Schedule Booking History',
        description: 'Heading'
    },
    updatedAt: {
        id: 'radicalstart.updatedAt',
        defaultMessage: 'Updated At',
        description: 'Label'
    },
    noOfServiceProvider: {
        id: 'radicalstart.noOfServiceProvider',
        defaultMessage: 'No. of. Service Provider',
        description: 'View booking Details'
    },
    requirements: {
        id: 'radicalstart.requirements',
        defaultMessage: 'Requirements',
        description: 'View booking Details'
    },
    requiredServiceHours: {
        id: 'radicalstart.requiredServiceHours',
        defaultMessage: 'Hours to complete the work',
        description: 'View booking Details'
    },
    specialInstruction: {
        id: 'radicalstart.specialInstruction',
        defaultMessage: 'Special instructions',
        description: 'View booking Details'
    },
    itemsFromUser: {
        id: 'radicalstart.itemsFromUser',
        defaultMessage: 'Items received from client',
        description: 'View booking Details'
    },
    newObservations: {
        id: 'radicalstart.newObservations',
        defaultMessage: 'Observations',
        description: 'View booking Details'
    },
    additionalNotes: {
        id: 'radicalstart.additionalNotes',
        defaultMessage: 'Additional notes',
        description: 'View booking Details'
    },
    photoVideoAudio: {
        id: 'radicalstart.photoVideoAudio',
        defaultMessage: 'Photo, Video, or Audio',
        description: 'View booking Details'
    },
    videoLabel: {
        id: 'radicalstart.videoLabel',
        defaultMessage: 'Video',
        description: 'View booking Details'
    },
    audioLabel: {
        id: 'radicalstart.audioLabel',
        defaultMessage: 'Audio',
        description: 'View booking Details'
    },
    serviceAmount: {
        id: 'radicalstart.serviceAmount',
        defaultMessage: 'Service Amount',
        description: 'Manage Incident Reports'
    },
    investigationDetails: {
        id: 'radicalstart.investigationDetails',
        defaultMessage: 'Investigation Details',
        description: 'Manage Incident Reports'
    },
    manageIncident: {
        id: 'radicalstart.manageIncident',
        defaultMessage: 'Manage Incident Reports',
        description: 'Manage Incident Reports'
    },
    incidents: {
        id: 'radicalstart.incidents',
        defaultMessage: 'Incident Reports',
        description: 'Manage Incident Reports Pagination'
    },
    incidentId: {
        id: 'radicalstart.incidentId',
        defaultMessage: 'Incident ID',
        description: 'Manage Incident Reports Pagination'
    },
    client: {
        id: 'radicalstart.client',
        defaultMessage: 'Client',
        description: 'View Incident Report'
    },
    siteLocation: {
        id: 'radicalstart.siteLocation',
        defaultMessage: 'Site Location',
        description: 'View Incident Report'
    },
    incidentReport: {
        id: 'radicalstart.incidentReport',
        defaultMessage: 'Incident Report #',
        description: 'View Incident Report'
    },
    incidentDateTime: {
        id: 'radicalstart.incidentDateTime',
        defaultMessage: 'Date and Time of Incident',
        description: 'View Incident Report'
    },
    incidentType: {
        id: 'radicalstart.incidentType',
        defaultMessage: 'Incident Type',
        description: 'View Incident Report'
    },
    whatType: {
        id: 'radicalstart.whatType',
        defaultMessage: 'If Other, What Type',
        description: 'View Incident Report'
    },
    victimName: {
        id: 'radicalstart.victimName',
        defaultMessage: 'Victim Name(s)',
        description: 'View Incident Report'
    },
    victimContact: {
        id: 'radicalstart.victimContact',
        defaultMessage: 'Victim Contact Info',
        description: 'View Incident Report'
    },
    suspectName: {
        id: 'radicalstart.suspectName',
        defaultMessage: 'Suspect Name(s)',
        description: 'View Incident Report'
    },
    suspectContact: {
        id: 'radicalstart.suspectContact',
        defaultMessage: 'Suspect Contact Info',
        description: 'View Incident Report'
    },
    witnessName: {
        id: 'radicalstart.witnessName',
        defaultMessage: 'Witness(es)',
        description: 'View Incident Report'
    },
    witnessContact: {
        id: 'radicalstart.witnessContact',
        defaultMessage: 'Witness Contact Info',
        description: 'View Incident Report'
    },
    incidentLocation: {
        id: 'radicalstart.incidentLocation',
        defaultMessage: 'Incident Location',
        description: 'View Incident Report'
    },
    incidentSummary: {
        id: 'radicalstart.incidentSummary',
        defaultMessage: 'Incident Summary',
        description: 'View Incident Report'
    },
    policeCalled: {
        id: 'radicalstart.policeCalled',
        defaultMessage: 'Police Called',
        description: 'View Incident Report'
    },
    ifNotWhy: {
        id: 'radicalstart.ifNotWhy',
        defaultMessage: 'If Not, Why?',
        description: 'View Incident Report'
    },
    policeNameBadge: {
        id: 'radicalstart.policeNameBadge',
        defaultMessage: 'Police Name(s) & Badge(s)',
        description: 'View Incident Report'
    },
    fireTruckNumber: {
        id: 'radicalstart.fireTruckNumber',
        defaultMessage: 'Fire Truck Number',
        description: 'View Incident Report'
    },
    ambulanceNumber: {
        id: 'radicalstart.ambulanceNumber',
        defaultMessage: 'Ambulance Number',
        description: 'View Incident Report'
    },
    whoWhatWhen: {
        id: 'radicalstart.whoWhatWhen',
        defaultMessage: 'Who, What, When, etc..',
        description: 'View Incident Report'
    },
    driverActions: {
        id: 'radicalstart.driverActions',
        defaultMessage: 'Services Provider Actions',
        description: 'View Incident Report'
    },
    incidentDetails: {
        id: 'radicalstart.incidentDetails',
        defaultMessage: 'Incident Details',
        description: 'Incident Details'
    },
    manageOfficerType: {
        id: 'radicalstart.manageOfficerType',
        defaultMessage: 'Manage Officer Type',
        description: 'Manage Officer Type'
    },
    countLabel: {
        id: 'radicalstart.countLabel',
        defaultMessage: 'Count',
        description: 'Count'
    },
    invalidCount: {
        id: 'radicalstart.invalidCount',
        defaultMessage: 'Invalid Count',
        description: 'Invalid Count'
    },
    areYouSureDeleteOfficer: {
        id: 'radicalstart.areYouSureDeleteOfficer',
        defaultMessage: 'Are you sure you want to delete this?',
        description: 'areYouSureDeleteOfficer',
    },
    confirmDelete: {
        id: 'radicalstart.confirmDelete',
        defaultMessage: 'Confirm Delete',
        description: 'confirmDelete',
    },
    deleteOfficer: {
        id: 'radicalstart.deleteOfficer',
        defaultMessage: 'Delete Officer',
        description: 'Delete Officer',
    },
    profileOfficerType: {
        id: 'radicalstart.profileOfficerType',
        defaultMessage: 'Officer type',
        description: 'Officer type',
    },
    profileOfficer: {
        id: 'radicalstart.profileOfficer',
        defaultMessage: 'Officer',
        description: 'Officer type',
    },
    manageDocumentsHeading: {
        id: 'radicalstart.manageDocumentsHeading',
        defaultMessage: 'Manage Documents',
        description: 'Manage documents'
    },
    documentName: {
        id: 'radicalstart.documentName',
        defaultMessage: 'Document name',
        description: 'Manage documents'
    },
    documentId: {
        id: 'radicalstart.documentId',
        defaultMessage: 'ID',
        description: 'Manage documents'
    },
    documentType: {
        id: 'radicalstart.documentType',
        defaultMessage: 'Document type',
        description: 'Manage documents'
    },
    documentEnable: {
        id: 'radicalstart.documentEnable',
        defaultMessage: 'Enable and disable',
        description: 'Manage documents'
    },
    vehicleDocument: {
        id: 'radicalstart.vehicleDocument',
        defaultMessage: 'Service document',
        description: 'Manage documents'
    },
    driverDocument: {
        id: 'radicalstart.driverDocument',
        defaultMessage: 'Service Provider document',
        description: 'Manage documents'
    },
    manageDocumentModalHeading: {
        id: 'radicalstart.manageDocumentModalHeading',
        defaultMessage: 'Document creation',
        description: 'Manage documents'
    },
    usersCity: {
        id: 'radicalstart.usersCity',
        defaultMessage: 'City',
        description: 'Manage Users'
    },
    usersState: {
        id: 'radicalstart.usersState',
        defaultMessage: 'State',
        description: 'Manage Users'
    },
    usersZipcode: {
        id: 'radicalstart.usersZipcode',
        defaultMessage: 'Zipcode',
        description: 'Manage Users'
    },
    usersStreet: {
        id: 'radicalstart.usersStreet',
        defaultMessage: 'Street',
        description: 'Manage Users'
    },
    serviceProviderDocument: {
        id: 'radicalstart.serviceProviderDocument',
        defaultMessage: 'Service Provider Document',
        description: 'Manage Users'
    },
    countExceedLimit: {
        id: 'radicalstart.countExceed',
        defaultMessage: 'Count should be lesser than 5000',
        description: 'Count should be lesser than 5000'
    },
    disclaimerContent: {
        id: 'radicalstart.disclaimerContent',
        defaultMessage: 'Disclaimer content',
        description: 'Sitesettings label'
    },
    disclaimerContentExceeded: {
        id: 'radicalstart.disclaimerContentExceeded',
        defaultMessage: 'Disclaimer content must be 100 characters or less',
        description: 'Disclaimer content must be 100 characters or less'
    },
    verificationDocument: {
        id: 'radicalstart.verificationDocument',
        defaultMessage: 'Verification document',
        description: 'Manage documents'
    },
    verificationDocumentType: {
        id: 'radicalstart.verificationDocumentType',
        defaultMessage: 'Verification',
        description: 'Manage documents'
    },
    cancelledByClient: {
        id: 'radicalstart.cancelledByClient',
        defaultMessage: 'Cancelled by client',
        description: 'Manage incident reports'
    },
    cancelledByServiceProvider: {
        id: 'radicalstart.cancelledByServiceProvider',
        defaultMessage: 'Cancelled by service provider',
        description: 'Manage incident reports'
    },
    facebookLink: {
        id: 'radicalstart.facebookLink',
        defaultMessage: 'Facebook URL',
        description: 'Facebook URL'
    },
    twitterLink: {
        id: 'radicalstart.twitterLink',
        defaultMessage: 'Twitter URL',
        description: 'Twitter URL'
    },
    instagramLink: {
        id: 'radicalstart.instagramLink',
        defaultMessage: 'Instagram URL',
        description: 'Instagram URL'
    },
    youtubeLink: {
        id: 'radicalstart.youtubeLink',
        defaultMessage: 'Youtube URL',
        description: 'Youtube URL'
    },
    merchandiseURL: {
        id: 'radicalstart.merchandiseURL',
        defaultMessage: 'Merchandise URL',
        description: 'Merchandise URL'
    },
    documentRequired: {
        id: 'radicalstart.documentRequired',
        defaultMessage: 'Required',
        description: 'Manage documents'
    },
    documentOptional: {
        id: 'radicalstart.documentOptional',
        defaultMessage: 'Optional',
        description: 'Manage documents'
    },
    documentStatus: {
        id: 'radicalstart.documentStatus',
        defaultMessage: 'Document status',
        description: 'Manage documents'
    },
    vehicleNamePlaceHolder: {
        id: 'radicalstart.vehicleNamePlaceHolder',
        defaultMessage: `Enter the Vehicle Make and Model name or 'NA'`,
        description: `Enter the Vehicle Make and Model name or 'NA'`
    },
    vehicleNumberPlaceHolder: {
        id: 'radicalstart.vehicleNumberPlaceHolder',
        defaultMessage: `Enter the Vehicle Plate Number or 'NA'`,
        description: `Enter the Vehicle Plate Number or 'NA'`
    },
    manageAdvertisement: {
        id: 'radicalstart.manageAdvertisement',
        defaultMessage: 'Manage advertisement',
        description: 'Manage advertisement'
    },
    manageAdverdisementHeading: {
        id: 'radicalstart.manageAdverdisementHeading',
        defaultMessage: 'Manage advertisement',
        description: 'Manage advertisement'
    },
    stateName: {
        id: 'radicalstart.StateName',
        defaultMessage: 'State',
        description: 'State '
    },
    advertisementEnable: {
        id: 'radicalstart.advertisementEnable',
        defaultMessage: 'Enable/Disable',
        description: 'Enable/Disable'
    },
    videoURL: {
        id: 'radicalstart.videoURL',
        defaultMessage: 'Video URL',
        description: 'Video URL '
    },
    save: {
        id: 'radicalstart.save',
        defaultMessage: 'Save',
        description: 'Save'
    },
    videoURLLengthExceedLimit: {
        id: 'radicalstart.videoURLLengthExceedLimit',
        defaultMessage: 'Count should be lesser than 1000',
        description: 'Count should be lesser than 1000'
    },
    incidentReportId: {
        id: 'radicalstart.incidentReportId',
        defaultMessage: 'ID',
        description: 'ID',
    },
    editIncidentReport: {
        id: 'radicalstart.editIncidentReport',
        defaultMessage: 'Edit Incident Reports',
        description: 'Edit Incident Reports',
    },
    incidentCataogy: {
        id: 'radicalstart.incidentCataogy',
        defaultMessage: 'Category',
        description: 'Category',
    },
    numberValueError: {
        id: 'radicalstart.numberValueError',
        defaultMessage: 'It should be a number value',
        description: 'It should be a number value'
    },
    whoWhatWhenTwo: {
        id: 'radicalstart.whoWhatWhenTwo',
        defaultMessage: 'Who, What, When, etc.',
        description: 'Who, What, When, etc.'
    },
    incidentFileType: {
        id: 'radicalstart.incidentFileType',
        defaultMessage: 'Choose your file',
        description: 'Choose your file'
    },
    photo: {
        id: 'radicalstart.photo',
        defaultMessage: 'Photo',
        description: 'Photo'
    },
    video: {
        id: 'radicalstart.video',
        defaultMessage: 'Video',
        description: 'Video'
    },
    audio: {
        id: 'radicalstart.audio',
        defaultMessage: 'Audio',
        description: 'Audio'
    },
    incidentFileUpload: {
        id: 'radicalstart.incidentFileUpload',
        defaultMessage: 'Choose your file',
        description: 'Choose your file',
    },
    decriptionlimit: {
        id: 'radicalstart.decriptionlimit',
        defaultMessage: 'Count should be lesser than 4000',
        description: 'Count should be lesser than 4000'
    },
    fcmPushNotificationKey: {
        id: 'app.fcmPushNotificationKey',
        defaultMessage: 'FCM push notification key',
        description: 'fcmPushNotificationKey',
    },
    driverSha: {
        id: 'radicalstart.driverSha',
        defaultMessage: 'Driver SHA key',
        description: 'driverSha'
    },
    riderSha: {
        id: 'radicalstart.riderSha',
        defaultMessage: 'Rider SHA key',
        description: 'riderSha'
    },
    keyExceed: {
        id: 'radicalstart.keyExceed',
        defaultMessage: 'Limit exceeded!. The key limit should be maximum of 1000 characters. ',
        description: 'Limit exceeded!. The key limit should be maximum of 1000 characters. '
    },
    locationWarning: {
        id: 'radicalstart.locationWarning',
        defaultMessage: 'We don\'t recognize that location',
        description: 'locationWarning'
    }
});

export default messages;
